import React, { useState,useEffect } from "react";
import { toast } from 'react-toastify';
import Loader from './Loader';
import ApiService from '../services/ApiService';
import { Modal, Button } from 'react-bootstrap';
import ImageUpload from '../components/ImageUpload';

function AddQuestion({ test_id, subset_id, updateQuestions, editQuestion, closeModal  }) {
  console.log('subset_id',subset_id)
  const [isLoader, setIsLoader] = useState(false);
  const [detailType, setDetailType] = useState('old');
  const [questionDetails, setQuestionDetails] = useState([]);
  
  const [formData, setFormData] = useState({ 
    detail_id: '', 
    detail: {
      "text":"",
      "image":"",
    },
    text: '', 
    image: null, 
    answer_details: '', 
    answer_image: '', 
    options: [] 
  }); // Track the current question

  useEffect(() => {
    getQuestionDetails();
    console.log(editQuestion,'editQuestion');
    if (editQuestion) {
      setFormData({
        text: editQuestion.text || '',
        image: editQuestion.image || null,
        answer_details: editQuestion.answer_details || '',
        answer_image: editQuestion.answer_image || null,

        detail_id: editQuestion.detail_id || '',
        options: editQuestion.options || [],
        detail: editQuestion.detail || null,
      });
    }
  }, [editQuestion]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleImageChange = (name, file) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: file,
    }));
  };
  const handleDetailTextChange = (e) => {
    const { value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      detail: {
        ...prevFormData.detail,
        text: value, // Update text inside the detail object
      },
    }));
  };

  // Handle change for image inside detail
  const handleDetailImageChange = (name, file) => {
    // console.log(name);
    setFormData((prevFormData) => ({
      ...prevFormData,
      detail: {
        ...prevFormData.detail,
        image: file, // Assuming one file is selected
      },
    }));
    console.log(formData);
  };

  const handleOptionImageChange = (index, file) => {
    console.log(file);
    setFormData((prevFormData) => {
      const updatedOptions = [...prevFormData.options];
      if (updatedOptions[index]) {
        updatedOptions[index].image = file; // Update image for the option at the given index
      }
      return {
        ...prevFormData,
        options: updatedOptions,
      };
    });
  };

  const newOption = () => {
    setFormData({
      ...formData,
      options: [...formData.options, { text: '', image: null, is_correct: false }]
    });
  };



  const updateOption = (oIndex, field, value) => {
    const updatedOptions = [...formData.options];
    //Is COrrect Case
    if (field === 'is_correct' && value) {
      updatedOptions.forEach((opt, index) => {
        if (index !== oIndex) {
          opt.is_correct = false; // Uncheck all other options
        }
      });
    }
    updatedOptions[oIndex][field] = value;
    setFormData({
      ...formData,
      options: updatedOptions
    });
  };

  const deleteOption = async (oIndex, optId) => {
    const updatedOptions = [...formData.options];
    updatedOptions.splice(oIndex, 1);
    setFormData({
      ...formData,
      options: updatedOptions
    });
    if (optId > 0) {
      try {
        const response = await ApiService.request({
          method: 'DELETE',
          url: 'delOption/'+optId, // Replace with your API endpoint
        });
  
        if (response.data.status) {
          // toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error('Form submission failed:', error);
      }
    }
    


  };

  const saveQuestion = async (e) => {
    e.preventDefault(); // Prevent default form submission
    setIsLoader(true);
    try {
      // Create FormData for single question
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });
      data.append('test_id', test_id);
      data.append('subset_id', subset_id);

      formData.options.forEach((option, oIndex) => {
        data.append(`options[${oIndex}][id]`, option?.id);
        data.append(`options[${oIndex}][text]`, option.text);
        data.append(`options[${oIndex}][is_correct]`, option.is_correct);

        if (option.image) {
          data.append(`options[${oIndex}][image]`, option.image);
        }
      });
        
      data.append(`detail[text]`, formData.detail?.text ?? '');
      if (formData?.detail?.image) {
        data.append(`detail[image]`, formData.detail.image);
      }

      const response = await ApiService.request({
        method: 'POST',
        url: 'questions/createOrUpdate/'+editQuestion?.id, // Replace with your API endpoint
        data: data
      });

      if (response.data.status) {
        toast.success(response.data.message);
        closeModal();
        updateQuestions();
      } else {
        toast.error(response.data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.error('Form submission failed:', error);
      setIsLoader(false);
    }
  };

  const getQuestionDetails = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `question-details`, // Replace with your API endpoint
        data: {'test_id':test_id,'subset_id':subset_id},
      });
      const data = response.data;
      if (data.status) {
        setQuestionDetails(data.data);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };



  return (
    <div>
      <div className="backdrop"></div>
      {/* Modal for Question */}
      <div
        className="modal fade show"
        id="exampleModalLive"
        tabIndex="-1"
        aria-labelledby="exampleModalLiveLabel"
        aria-modal="true"
        role="dialog"
        style={{ display: 'block' }}
      >
        <div className="modal-dialog modal-xl modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4>Add Question</h4>
            </div>

            <form onSubmit={saveQuestion}>
              <div className="modal-body">
              <div className="row">
                  <div className="col-md-10 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Question Details   </label>
                      <select  value={detailType}  className="mx-3"
                        onChange={(e) => setDetailType(e.target.value)} >
                        <option value="new">Add New</option>  
                        <option value="old">Select Old</option>  
                      </select>
                      {detailType== "new" ?(
                          <textarea
                            name="detail.text"
                            className="form-control form-control-solid"
                            rows={4}
                            value={formData.detail?.text} 
                            onChange={handleDetailTextChange}
                            placeholder="Write Question..."  >
                          </textarea>
                      ):(
                        <select  value={formData.detail_id}  name="detail_id" className="form-select"
                          onChange={handleChange} id="">
                          <option value="">Select Question Detail</option>  
                          {questionDetails.map((question, index) => (
                          <option value={question.id} key={index}>{question.text}</option>  
                          ))}
                        </select>  
                      )}
              
                  </div>
                  {detailType== "new" &&
                    <div className="col-md-2 fv-row fv-plugins-icon-container">
                      <label className="fs-6 fw-semibold mb-2"> Image (optional)</label>
                      <ImageUpload
                        name="image"
                        onImageChange={handleDetailImageChange}
                        defaultPreviewUrl={formData.detail?.image}
                      />
                    </div>
                  }

                </div>

                <div className="row my-3">
                  <div className="col-md-10 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2"> Question </label>
                    <textarea
                      name="text"
                      className="form-control form-control-solid"
                      rows={3}
                      value={formData.text} 
                      onChange={handleChange}
                      placeholder="Write Question..."  ></textarea>
                  </div>
                  <div className="col-md-2 fv-row fv-plugins-icon-container">
                    <label className="fs-6 fw-semibold mb-2"> Image (optional)</label>
                    <ImageUpload
                      name="image"
                      onImageChange={handleImageChange}
                      defaultPreviewUrl={formData.image}
                    />
                  </div>
                  <div className="col-md-10 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2"> Explain Answer</label>
                    <textarea
                      name="answer_details"
                      className="form-control form-control-solid"
                      rows={3}
                      value={formData.answer_details}
                      onChange={handleChange}
                      placeholder="Explain Answer..."></textarea>
                  </div>
                  <div className="col-md-2 fv-row fv-plugins-icon-container">
                    <label className="fs-6 fw-semibold mb-2"> Image (optional)</label>
                    <ImageUpload
                      name="answer_image"
                      onImageChange={handleImageChange}
                      defaultPreviewUrl={formData.answer_image}
                    />
                  </div>
                </div>
                {/* //Options */}
                <h4 className="my-3">
                  Options
                  <button
                    type="button"
                    className="btn btn-sm btn-base mx-5"
                    onClick={newOption}
                  >
                    Add Option
                  </button>
                </h4>
                {formData.options.map((opt, index) => (
                  <div className="row py-3 border border-top border-bottom" key={index}>
                    <div className="col-md-9 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2"> Option Text</label>
                      <textarea
                        name="text"
                        className="form-control form-control-solid"
                        rows={4}
                        value={opt.text}
                        onChange={(e) => updateOption(index, 'text', e.target.value)}
                        placeholder="Write option text"
                      ></textarea>
                    </div>
                    <div className="col-md-2 fv-row fv-plugins-icon-container">
                      <label className="fs-6 fw-semibold mb-2"> Image </label>
                      <ImageUpload
                        name="image"
                        onImageChange={(name,file) => handleOptionImageChange(index, file)}
                        defaultPreviewUrl={opt.image}
                      />
                    </div>
                    <div className="col-md-1 ">
                        <label className="fs-6 fw-semibold mb-2" for={'option'+index}> Is Correct </label>
                        <input
                          id={'option' + index}
                          required
                          type="radio"
                          name="is_correctOption"
                          className="form-check-input mb-3"
                          checked={opt.is_correct}
                          onChange={(e) => updateOption(index, 'is_correct', e.target.checked)}
                        /><br />

                      <button   type="button"
                        className="btn btn-sm btn-base"
                        onClick={() => deleteOption(index, opt.id)}   >   X  </button>
                    </div>
                  </div>
                ))}
              </div>
              <div className="modal-footer">
                <Button
                  type="button"
                  onClick={closeModal}
                  className="btn btn-secondary me-3"
                >
                  Close
                </Button>
                <Button type="submit" className="btn btn-base me-3" disabled={isLoader}>
                   <span  hidden={isLoader}> Save  </span>
                    {isLoader && <Loader size="30" text="Saving" color="white" />}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddQuestion;
